import { Button, FormFieldAutocomplete, Option } from "@/shared/components";
import { UseFormReturn } from "react-hook-form";
import { NieuwDossierFormValues } from "../../utils";
import { OngewensteGebeurtenisOptionLabel } from "../shared";

export type OngewensteGebeurtenisOption = Option<{
    meldingtekst: string;
    spoorwebNr: string;
    TIS: string | undefined;
    timeSinceEvent: string | undefined;
}>;

type SelectStepProps = {
    form: UseFormReturn<NieuwDossierFormValues>;
    options: OngewensteGebeurtenisOption[];
    onSpoorwebSelect: (spoorwebNr: string) => void;
    continueWithoutOg: () => void;
};

export function SelectStep({ form, options, onSpoorwebSelect, continueWithoutOg }: Readonly<SelectStepProps>) {

    return (
        <div className="grid gap-4 p-6 pb-8">
            <FormFieldAutocomplete
                form={form}
                name="spoorwebNr"
                label="Spoorwebnummer"
                options={options}
                placeholder="Zoek spoorwebnummer"
                onChange={onSpoorwebSelect}
                renderOption={(option) => (
                    <OngewensteGebeurtenisOptionLabel
                        meldingtekst={option.meldingtekst}
                        spoorwebNr={option.spoorwebNr}
                        TIS={option.TIS}
                        timeSinceEvent={option.timeSinceEvent}
                    />
                )}
                className="max-w-sm"
                data-testid="spoorwebitems"
            />
            <Button variant="tertiary" className="w-fit px-0" onClick={continueWithoutOg}>
                Verder zonder spoorwebnummer
            </Button>
        </div>
    );
}
